import TranslationStages from './TranslationStages';

export default TranslationStages;
